const SLUG = "crm_tenant_slug";
const OV = "crm_tenant_override";

export const getSlug = () => localStorage.getItem(SLUG) || "";
export const setSlug = (s) => (s ? localStorage.setItem(SLUG, s) : localStorage.removeItem(SLUG));
export const getOverride = () => localStorage.getItem(OV) || "";
export const loginPath = () => (getSlug() ? `/login/${getSlug()}` : "/login");
export const loginUrl = (slug) => `${window.location.origin}/login/${slug}`;

export const switchTenant = (id) => {
  if (id) localStorage.setItem(OV, id); else localStorage.removeItem(OV);
  localStorage.removeItem("crm-filters");
  window.location.href = "/";
};

export const tenantHeaders = () => {
  const h = {};
  if (getSlug()) h["X-Tenant-Slug"] = getSlug();
  if (getOverride()) h["X-Tenant"] = getOverride();
  return h;
};
